import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';
import { reactive, watch } from 'vue';
import useAlerts from './useAlerts';
import useDecryptSymbols from './useDecryptSymbols';

const { addAlert } = useAlerts();
const { decryptSymbols } = useDecryptSymbols();

const pickLists = reactive({
  categories: { id: '4E773A92-E4A0-467C-BFDC-026449F7D767', name: 'Categories', items: [] },
  contactDepartments: { id: '1120BD82-B96E-4AC1-91DC-F7E9D80B6A3F', name: 'Contact Departments', items: [] },
  customerDetail: { id: '6A81174E-9961-4948-97D4-F66AD79F03CF', name: 'Customer Detail', items: [] },
  contactTitles: { id: 'F2E71B43-9FE2-4FD3-BA33-59371C57E11C', name: 'Contact Titles', items: [] },
  diaryTypes: { id: 'a99acfce-95a5-4413-a417-eca94767a157', name: 'Diary Types', items: [] },
  diaryProjects: { id: '734213FE-4480-11EA-B77F-2E728CE88125', name: 'Diary Projects', items: [] },
  interactionTypes: { id: '286aee1c-0d56-428f-83d1-f31ead643f5e', name: 'Interaction Types', items: [] },
  completionTypes: { id: '199bbd82-6acf-4a25-9495-75e4aeea3ae6', name: 'Lead Completion Types', items: [] },
  reminderTypes: { id: 'a2c6459c-52d3-475f-8c53-27bb3695b2ec', name: 'Reminder Types', items: [] },
  vendorDepartments: { id: 'D4E247DF-CCC3-48E7-AECF-78C00816C1E1', name: 'Vendor Departments', items: [] },
  vendorDetails: { id: 'C21D3A88-5779-49F2-835E-B17B67CFD53B', name: 'Vendor Details', items: [] },
  architectDetails: { id: 'd3059728-d022-4510-b08e-bd3af331aa80', name: 'Architect/Engineer Details', items: [] },
});

const PICKLIST_ITEMS_QUERY = gql`
  query PicklistItems($picklistid: ID!) {
    picklistItems(picklistid: $picklistid) {
      NAME
      PICKLISTID
      PICKLISTITEMID
      SCOREACTION
    }
  }
`;

const usePicklistItemsQuery = function () {
  for (const key in pickLists) {
    const picklistid = pickLists[key].id;
    const { result, error, refetch } = useQuery(PICKLIST_ITEMS_QUERY, () => ({ picklistid }));

    pickLists[key].refetch = refetch;

    watch(result, () => {
      const decrypted = decryptSymbols(result.value.picklistItems);
      pickLists[key].items.splice(0, pickLists[key].items.length, ...decrypted);
    });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching options:', error.value);
        addAlert('Error fetching user options', 'high', 4);
      }
    });
  }
};

const refetchPickLists = function () {
  for (const key in pickLists) {
    pickLists[key].refetch();
  }
};

export default { usePicklistItemsQuery, refetchPickLists, pickLists };
